<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                    Col
                        h2 {{ $t('alertrules.pageTitleText') }}
                    Col
                        ExplainBtn(:objectExplanation="objectsExplanation")
            p Create rules for event monitoring.
            strong You have created {{ usage.used }} of {{ usage.max }} alert rules.

        // h2 {{ $t('alertrules.pageTitleText') }}
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :drawerTitleKey="drawerTitleKey"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :sort="sort"
            ref="rcmTable"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="ruleName"
            :primarySearchKeyI18="$t('alertrules.ruleName')"
            :withFormExamples="true"
            :formExampleComponents="'AlertRulesFormExamples'"
            :isCreateBtnDisabled="!$can('write', 'domainManagePermission','AlertRules')"
            :isEditBtnDisabled="!$can('write', 'domainManagePermission','AlertRules')"
            :isDeleteBtnDisabled="!$can('write', 'domainManagePermission','AlertRules')"
        )
</template>
<script>
import Vue from "vue";
Vue.component("BlinkingIcon", BlinkingIcon);
Vue.component("RuleTestBtn", RuleTestBtn);
Vue.component("ViewLogsBtn", ViewLogsBtn);

import { settingZoneExplain, groupName, isEnabled, ruleName } from "./fields.js";

import RcmTable from "@/components/RcmTable_v2";
import BlinkingIcon from "@/components/BlinkingIcon";
import RuleTestBtn from "@/components/AlertRules/RuleTestBtn";
import ViewLogsBtn from "@/components/AlertRules/ViewLogsBtn";
import bus from "@/libs/bus.js";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);

import { getGroupAsset } from "@/api/groupasset.js";

export default {
    name: "AlertRules",
    components: { RcmTable, BlinkingIcon, RuleTestBtn },
    data() {
        return {
            esIndex: "rcm-alertrules",
            drawerTitleKey: "ruleName",
            addButtonText: "Add",
            sort: [{ modifiedDate: { order: "desc" } }],
            assetCategory: "alertRules",
            usage: { used: "", max: "", available: "" },
            objectsExplanation: {},
        };
    },
    computed: {
        sectionInfo() {
            let sectionInfo = [{ sectionKey: "essential", isOpened: true }];

            sectionInfo = sectionInfo.map((e) => {
                e.sectionName = this.$i18n.t(`alertrules.sections.${e.sectionKey}`);
                return e;
            });

            return sectionInfo;
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: {},
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      ruleName: ruleName(this),
                      _id: {},
                      isAlerting: {},
                      alertRuleQuery: {},
                      alertWhen: {},
                      alertValue: {},
                      alertValueInfo: {},
                      alertValueUnit: {},
                      alertChannelName: {},
                      alertMessage: {},
                      ruleTest: {},
                      viewLogs: {},
                      isenabled: isEnabled(this),
                      currentValue: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: {},
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      ruleName: ruleName(this),
                      _id: {},
                      isAlerting: {},
                      alertRuleQuery: {},
                      alertWhen: {},
                      alertValue: {},
                      alertValueInfo: {},
                      alertValueUnit: {},
                      alertChannelName: {},
                      alertMessage: {},
                      ruleTest: {},
                      viewLogs: {},
                      isenabled: isEnabled(this),
                      currentValue: {},
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      objectLog: {},
                  };
        },
    },
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName],
            }).then((res) => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        },
    },
    mounted() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        this.getAssetData();
    },
    created() {
        this.$bus = bus;
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent, args) => {
            // 如果是找我的事件就接收處理, 否則向下傳遞
            switch (busEvent) {
                case "":
                    break;
                default:
                    bus.$emit(busEvent);
                    break;
            }
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/AlertRules/Page.vue